import "./css/InfoClient.css";

export default function InfoClient({client}) {
  	return (
        <>
            <div className="card card-action mb-4">
                <div className="card-header align-items-center flex-wrap gap-2">
                    <h5 className="card-action-title mb-0">Informazioni</h5>
                    <div className="card-action-element">
                        <button className="btn btn-primary btn-sm edit-address" type="button">
                            <i className="bx bx-plus bx-xs me-1_5"></i>Modifica
                        </button>
                    </div>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-xl-7 col-12">
                            <dl className="row mb-0 gx-2">
                                <dt className="col-sm-4 mb-sm-2 text-nowrap fw-medium text-heading">PIVA:</dt>
                                <dd className="col-sm-8">{client.piva ? client.piva : 'Non inserita'}</dd>
                                <dt className="col-sm-4 mb-sm-2 text-nowrap fw-medium text-heading">CF:</dt>
                                <dd className="col-sm-8">{client.tax_code ? client.tax_code : 'Non inserito'}</dd>
                                <dt className="col-sm-4 mb-sm-2 text-nowrap fw-medium text-heading">PEC:</dt>
                                <dd className="col-sm-8">{client.email_pec ? client.email_pec : 'Non inserita'}</dd>
                                <dt className="col-sm-4 mb-sm-2 text-nowrap fw-medium text-heading">SDI:</dt>
                                <dd className="col-sm-8">{client.sdi ? client.sdi : 'Non inserito'}</dd>
                                <dt className="col-sm-4 mb-sm-2 text-nowrap fw-medium text-heading">Note:</dt>
                                <dd className="col-sm-8">{client.note ? client.note : 'Non inserite'}</dd>
                            </dl>
                        </div>
                        <div className="col-xl-5 col-12">
                            <dl className="row mb-0 gx-2">
                                <dt className="col-sm-4 mb-sm-2 text-nowrap fw-medium text-heading">Referente:</dt>
                                <dd className="col-sm-8">{client.referent ? client.referent : 'Non inserito'}</dd>
                                <dt className="col-sm-4 mb-sm-2 text-nowrap fw-medium text-heading">Cellulare:</dt>
                                <dd className="col-sm-8">{client.smartphone ? client.smartphone : 'Non inserito'}</dd>
                                <dt className="col-sm-4 mb-sm-2 text-nowrap fw-medium text-heading">Telefono:</dt>
                                <dd className="col-sm-8">{client.phone ? client.phone : 'Non inserito'}</dd>
                                <dt className="col-sm-4 mb-sm-2 text-nowrap fw-medium text-heading">Email:</dt>
                                <dd className="col-sm-8">{client.email ? client.email : 'Non inserita'}</dd>
                            </dl>
                        </div>
                    </div>
                </div>
            </div>
        </>
	);
}